import { render, staticRenderFns } from "./AvatarBeta.vue?vue&type=template&id=1eabc826&"
import script from "./AvatarBeta.vue?vue&type=script&lang=js&"
export * from "./AvatarBeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports